import React, {useState, useEffect, useRef, useMemo, useLayoutEffect, memo} from 'react';
import './App.css';
import { isMobile } from 'react-device-detect';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import {keepPreviousData, useQuery} from '@tanstack/react-query';

const equ =(pre,nex)=>{
 return (pre.tito == nex.tito);
};

const Pannela =({tito})=>{
const [dasi, setdasi] = useState(false);
const [mona, setmona] = useState(true);
const [noups, setnoups]= useState(false);
const [houps, sethoups]= useState(false);

const juka = useRef(null);
const moke = useRef(null);

const adaan = isMobile ? "maaan" : "aaan";
const admmn = isMobile ? "mmoewa" : "moewa";

const sono = () => {
   if (!moveon.current) return;
   clearTimeout(juka.current);
   clearTimeout(moke.current);
    const monzy = 100 / last?.h?.length;
    const mabos = last?.h?.length % 2 == 0 ? monzy / 2 : 0;
    
    moveon.current.style.transition = 'none';
    moveon.current.style.transform = `translateX(-${mabos}%)`;
    void moveon.current.offsetWidth;

    requestAnimationFrame(() => {
        moveon.current.style.transition = 'transform 0.5s ease-out';
        moveon.current.style.transform = `translateX(-${monzy + mabos}%)`;
    });

    juka.current = setTimeout(() => { 
        if(moveon.current == null) return;
        moveon.current.appendChild(moveon.current.firstElementChild);
        moveon.current.style.transition = 'none';
        moveon.current.style.transform = `translate(-${mabos}%)`;
        moke.current = setTimeout(() => {
            moveon.current.style.transition = 'transform 0.5s ease-out';
            setmona(!mona);
        }, 20);     
    }, 800);
};

const kuara = () => {
    setdasi(true);
};

const kirara = () => {
    setdasi(false);
};

const mahina = ()=>{
    setdasi(true);
};
const amena =()=>{
    setdasi(false);
};


const noflow = () =>{
    if(noups){
        return noups;
    }else{
        setnoups(true);
        return false;
    }
};

const ahflow = () =>{
    if(houps){
        return houps;
    }else{
        sethoups(true);
        return false;
    }
};

const supo = () => {
    if(noflow()) return;
    setdasi(true);
   
    const monzy = 100 / last?.h?.length;
    const mabos = last?.h?.length % 2 == 0 ? monzy / 2 : 0;
    moveon.current.style.transition = 'none';
    moveon.current.style.transform = `translate(-${mabos}%)`;
    void moveon.current.offsetWidth;
  
    requestAnimationFrame(() => {
    moveon.current.style.transition = 'transform 0.5s ease-out';
    moveon.current.style.transform = `translateX(-${monzy + mabos}%)`;
    });
      
    const juki = setTimeout(() => {
        moveon.current.appendChild(moveon.current.firstElementChild);
        moveon.current.style.transition = 'none';
        moveon.current.style.transform = `translate(-${mabos}%)`;
    
        const moa = setTimeout(() => {
            moveon.current.style.transition = 'transform 0.5s ease-out';
            setnoups(false);
        }, 20);
       clearTimeout(juki);
    }, 800);
};

const sdwo = () => {
    if(ahflow()) return;
    setdasi(true);
    const monzy = 100 / last?.h?.length;
    const mabos = last?.h?.length % 2 == 0 ? monzy / 2 : 0;
    moveon.current.style.transition = 'none';
    moveon.current.style.transform = `translateX(-${mabos}%)`;
    void moveon.current.offsetWidth;
    
    requestAnimationFrame(() => {
    moveon.current.style.transition = 'transform 0.5s ease-out';
    moveon.current.style.transform = `translateX(${monzy - mabos}%)`;
    });
 
    const juki = setTimeout(() => {
        moveon.current.prepend(moveon.current.lastElementChild);
        moveon.current.style.transition = 'none';
        moveon.current.style.transform = `translate(-${mabos}%)`;
        
        const moa = setTimeout(() => {
            moveon.current.style.transition = 'transform 0.5s ease-out';
            sethoups(false);
        }, 20);
        clearTimeout(juki);
    }, 800);
    
};

const fnax = async (signal) => {
    const { data : hooko } = await axios.get('/api/carousel', { signal });
    const data = {h : vggle(hooko.main), z : zggle(hooko.subm), a : uggle(hooko.sub1), b: uggle(hooko.sub2), c: uggle(hooko.sub3), d: aggle(hooko.sub3, hooko.event), e:uggle(hooko.event)};
    return data;
};

const {isPending, data : last} = useQuery({queryKey:['ka'], queryFn: ({signal})=>fnax(signal), 
placeholderData: keepPreviousData, staleTime: 1000 * 60 * 5, gcTime: 1000 * 60 * 30 });


useEffect(() => {
 
    if (dasi == true) return;
    if (!last?.h?.length) return;
    if(last?.h?.length <= 1) return;
    const kci = setTimeout(() => { sono(); }, 3500);
    return () => { clearTimeout(kci); };
},
    [mona, dasi, last]);

const moveon = useRef();
    
const uggle =(arar)=>{
    if(arar.length === 0 || arar === undefined) return arar;
    for (let i = arar.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [arar[i], arar[j]] = [arar[j], arar[i]];
      };
     return arar;
};

const vggle =(arar)=>{
    if(arar.length === 0) return [{link : "#", image : "dolpa_m.png", period : "", title : "돌파공모"}];
   
    for (let i = arar.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [arar[i], arar[j]] = [arar[j], arar[i]];
      };

    if (arar.length === 2) {
        return [...arar, {link : "#", image : "dolpa_m.png", period : "", title : "돌파공모"}];
    };

    return arar;
};

const zggle =(arar)=>{
    if(arar.length === 0) return [{link : "#", image : "dolpa_s.png", period : "", title : "돌파공모"}];
   
    for (let i = arar.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [arar[i], arar[j]] = [arar[j], arar[i]];
      };

    if (arar.length === 2) {
        return [...arar, {link : "#", image : "dolpa_s.png", period : "", title : "돌파공모"}];
    }else if(arar.length === 4) {
        return [...arar, {link : "#", image : "dolpa_s.png", period : "", title : "돌파공모"}];
    };

    return arar;
};
  
const aggle =(a, b)=>{
    const ugoka = a.concat(b);
    if(ugoka === undefined) return [];
    for (let i = ugoka.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [ugoka[i], ugoka[j]] = [ugoka[j], ugoka[i]];
      };
     return ugoka;
};

return(
<div className={adaan}>
<div className={admmn}>
    {last && <div className='slid' ref={moveon} onMouseOver={kuara} onMouseOut={kirara} style={{ '--total-count': last ? last.h.length : 1, '--nanoo': last.h.length%2 == 1 ? 0 : 1 }}>
        {last && last?.h?.map((con, i)=>{ return (<div className='iware'>
            <Link to={`ajo/${con.link}`} className='iwang' onClick={()=>{ 
                window.history.pushState({nopi : window.scrollY},null,null); 
                window.history.states = {nopi : window.scrollY}; 
                window.history.tates = {nopi : window.scrollY};}}>
            <img src={process.env.PUBLIC_URL+`/document/${con.image}`}/>
            <div className='fly'>
                <p>{con.period}</p>
                <p>{con.title}</p>
            </div>
            </Link> 
        </div>)})}
    </div>}
    {last?.h?.length > 1 && <div className='contra'>
        <span className='ape' onClick={supo} onMouseOver={mahina} onMouseOut={amena}><img src={process.env.PUBLIC_URL+'/sidel.png'}/></span>
        <span className='due' onClick={sdwo} onMouseOver={mahina} onMouseOut={amena}><img src={process.env.PUBLIC_URL+'/sider.png'}/></span>
    </div>}
</div>
</div>
)
};
// export {Pannela as Pannel, equ};
// export default Pannel;
export const Pannel = memo(Pannela, equ);